<template>
  <div class="brands-marketplace-navigation-wrapper">
    <div v-for="(filter, index) in filtersList"
         :key="index"
         class="filters-wrapper"
         @click="handleAnchorClick(filter.refName, filter.id)">
      {{ filter.name }}
      <fai class="filter-icon" :class="{show: filter.id === activeListId}" :icon="['fas', 'caret-left']" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      showStateNav: Boolean,
      showSponsoredNav: Boolean,
      showStoreNav: Boolean
    },

    name: 'BrandsMarketplaceNavigation',

    data() {
      return {
        activeListId: null,
        filtersList: [
          {
            name: 'by state',
            refName: 'by-state',
            id: 0
          },
          {
            name: 'previously sponsored',
            refName: 'sponsored',
            id: 1
          },
          {
            name: 'in-store',
            refName: 'in-store',
            id: 2
          }
        ]
      }
    },

    methods: {
      handleAnchorClick(ref, id) {
        this.activeListId = id
        this.$emit('scrollToCarousel', ref)
      },
    },

    mounted() {
      if (!this.showStateNav) {
        this.filtersList = this.filtersList.filter(x => x.id !== 0)
      }

      if (!this.showSponsoredNav) {
        this.filtersList = this.filtersList.filter(x => x.id !== 1)
      }

      if (!this.showStoreNav) {
        this.filtersList = this.filtersList.filter(x => x.id !== 2)
      }
    }
  }

</script>

<style scoped>
.brands-marketplace-navigation-wrapper {
  display: flex;
  color: #128ff9;
  justify-content: center;
  border-top: 1px solid #128ff9;
  padding: .8rem 0;
}

.filters-wrapper {
  display: flex;
  font-size: 1.1em;
  align-items: center;
  cursor: pointer;
}

.filters-wrapper:not(:first-child):not(:last-child) {
  margin: 0 3rem;
}

.filter-icon {
  font-size: 1.1em;
  margin-left: 5px;
  visibility: hidden;
}

.filter-icon.show {
  visibility: visible;
}
</style>
